/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Checklist template. Defaults to custom_app.
 */
export const ListingMode = {
  CustomApp: "custom_app",
  Oin: "oin",
} as const;
/**
 * Checklist template. Defaults to custom_app.
 */
export type ListingMode = ClosedEnum<typeof ListingMode>;

export type CreateIdentityProviderConnectionRequestBody = {
  /**
   * Checklist template. Defaults to custom_app.
   */
  listingMode?: ListingMode | undefined;
  /**
   * Okta org URL, for example https://example.okta.com. Must be https on an Okta-owned domain with no path, except an Admin Console URL with an /admin path, which resolves to its org.
   */
  orgUrl: string;
};

/** @internal */
export const ListingMode$outboundSchema: z.ZodMiniEnum<typeof ListingMode> = z
  .enum(ListingMode);

/** @internal */
export type CreateIdentityProviderConnectionRequestBody$Outbound = {
  listing_mode?: string | undefined;
  org_url: string;
};

/** @internal */
export const CreateIdentityProviderConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    CreateIdentityProviderConnectionRequestBody$Outbound,
    CreateIdentityProviderConnectionRequestBody
  > = z.pipe(
    z.object({
      listingMode: z.optional(ListingMode$outboundSchema),
      orgUrl: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        listingMode: "listing_mode",
        orgUrl: "org_url",
      });
    }),
  );

export function createIdentityProviderConnectionRequestBodyToJSON(
  createIdentityProviderConnectionRequestBody:
    CreateIdentityProviderConnectionRequestBody,
): string {
  return JSON.stringify(
    CreateIdentityProviderConnectionRequestBody$outboundSchema.parse(
      createIdentityProviderConnectionRequestBody,
    ),
  );
}
